import api from './api';

const trackingService = {
    async trackVisit(data) {
        try {
            const response = await api.post('/track/visit', data);
            return response.data;
        } catch (error) {
            console.error('Error in trackVisit:', error);
            throw error;
        }
    },

    async trackAction(actionType, data) {
        try {
            const response = await api.post('/track/action', {
                actionType,
                ...data,
                timestamp: new Date().toISOString()
            });
            return response.data;
        } catch (error) {
            console.error('Error in trackAction:', error);
            throw error;
        }
    },

    async trackFunnelEvent(data) {
        try {
            const response = await api.post('/track/funnel/event', data);
            return response.data;
        } catch (error) {
            // Le tracking ne doit jamais bloquer le parcours utilisateur.
            console.error('Error tracking funnel event:', error);
            return null;
        }
    },

    async trackSignup(data) {
        return this.trackAction('SIGNUP', data);
    },

    async trackLike(data) {
        return this.trackAction('LIKE', data);
    },

    async trackMatch(data) {
        return this.trackAction('MATCH', data);
    },

    async trackMessage(data) {
        return this.trackAction('MESSAGE', data);
    },

    async getTrackingStats(ref) {
        try {
            const response = await api.get(`/track/stats/${ref}`);
            return response.data;
        } catch (error) {
            console.error('Error in getTrackingStats:', error);
            throw error;
        }
    }
};

export default trackingService;
